module.exports = __webpack_public_path__ + "static/img/usdc.759aaeea.png";